import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { isKPIChartEnhancementsEnabled } from '@thoughtspot/session-service';
import { isKpiChartTypeTimeseries, shouldIncludeEnhancedKpiSettings, } from '../../../components/kpi/kpi-utils';
import { ColumnType } from '../../../types';
import { ChartSettingsV2MenuItems, } from '../chart-settings-v2-schema.types';
import { createAnomalyLabelledView, createChangeSectionLabelledView, createChartColumnNumberFormatter, createColumnColorPicker, createColumnNameTextInput, createCommonConditionalFormatter, createComparisonLabelledView, createComparisonLabelledViewForKPI, createHideNullValuesCheckbox, createAnomalyLabelledViewForKPI, createKPISparklineColorPicker, createMaxDataPointsInput, createMissingValuesDropdown, createShowEnableAnalyseCheckbox, createShowLabelCheckbox, createShowNullDataAsDropdown, createShowSparklineCheckbox, createTimeBucketDropdown, createTooltipContentFormatter, createTooltipVisibilityCheckbox, } from '../schema-composer-utils/common-elements';
import { shouldHideAnomalySettings } from '../schema-composer-utils/common-rules';
import { createAccordion, createAccordionItem, createSection, } from '../schema-composer-utils/elements';
const getNewDisplaySettings = () => {
    return [
        createSection({
            properties: {
                showDivider: false,
            },
            children: [
                createMaxDataPointsInput(),
            ],
        }),
        createSection({
            children: [
                createChangeSectionLabelledView(),
            ],
        }),
        createSection({
            children: [createAnomalyLabelledViewForKPI()],
            isHiddenCallback: shouldHideAnomalySettings,
        }),
    ];
};
const getLegacyDisplaySettings = () => {
    return [
        createSection({
            children: [
                createMaxDataPointsInput(),
                createShowLabelCheckbox(),
                createShowSparklineCheckbox(),
                createShowEnableAnalyseCheckbox(),
            ],
        }),
        createSection({
            children: [createComparisonLabelledView()],
        }),
        createSection({
            children: [createAnomalyLabelledView()],
            isHiddenCallback: shouldHideAnomalySettings,
        }),
    ];
};
const columnSettings = (isTimeSeries) => [
    {
        type: ColumnType.Attribute,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                properties: {
                                    header: '',
                                    isExpanded: true,
                                    noPadding: true,
                                    variant: 'sideNav',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    createCommonConditionalFormatter(),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Measure,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createChartColumnNumberFormatter(),
                                    ...(shouldIncludeEnhancedKpiSettings(isTimeSeries)
                                        ? [
                                            createCommonConditionalFormatter(),
                                            createShowNullDataAsDropdown(),
                                            createKPISparklineColorPicker(),
                                            createMissingValuesDropdown({
                                                properties: {
                                                    label: 'MISSING_DATES',
                                                    childrenSize: 'large',
                                                    orientation: 'Vertical',
                                                    icon: IconID.INFORMATION_CIRCLE,
                                                    tooltip: 'chartSettings.kpi.missingDates.tooltip',
                                                },
                                                translate: [
                                                    'label',
                                                    'tooltip',
                                                ],
                                            }),
                                        ]
                                        : [
                                            createColumnColorPicker(),
                                            createCommonConditionalFormatter(),
                                            createShowNullDataAsDropdown(),
                                        ]),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
    {
        type: ColumnType.Date,
        settings: [
            createSection({
                children: [
                    createAccordion({
                        properties: {
                            spacing: 'ignore',
                        },
                        children: [
                            createAccordionItem({
                                key: 'columnName',
                                runTimeProperties: {
                                    header: 'TS_INPUT',
                                },
                                children: [
                                    createColumnNameTextInput(),
                                    createTimeBucketDropdown(),
                                    createHideNullValuesCheckbox(),
                                    ...(shouldIncludeEnhancedKpiSettings(isTimeSeries)
                                        ? [createComparisonLabelledViewForKPI()]
                                        : []),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ],
    },
];
const tooltipSettings = [
    createSection({
        children: [
            createTooltipVisibilityCheckbox(),
            createTooltipContentFormatter(),
        ],
    }),
];
export const getKpiChartSettingsSchema = (chartViz) => {
    const isTimeSeries = chartViz && isKpiChartTypeTimeseries(chartViz);
    const displaySettings = isKPIChartEnhancementsEnabled()
        ? getNewDisplaySettings()
        : getLegacyDisplaySettings();
    return {
        [ChartSettingsV2MenuItems.COLUMN]: columnSettings(isTimeSeries),
        [ChartSettingsV2MenuItems.AXIS]: null,
        [ChartSettingsV2MenuItems.DATA_LABEL]: null,
        [ChartSettingsV2MenuItems.TOOLTIP]: isTimeSeries
            ? tooltipSettings
            : null,
        [ChartSettingsV2MenuItems.LEGEND]: null,
        [ChartSettingsV2MenuItems.DISPLAY]: isTimeSeries
            ? displaySettings
            : null,
    };
};
//# sourceMappingURL=kpi-schema.js.map